<template>
  <div id="app" :class="id">
    <router-view/>
    <notifications group="plk" position="bottom right"/>
    <v-dialog/>
  </div>
</template>

<script>
import Vue from 'vue'
import { APP_NOTIFICATION_TIME } from '@/enviroment/app'
import VModal from 'vue-js-modal'
Vue.use(VModal, { dialog: true })

export default {
  name: 'app',
  mounted () {
    this.$servicesPLK.event.onEvent(this.$servicesPLK.event.BASIC_ACTIONS.ERROR, this.notifyError)
  },
  computed: {
    id () {
      return this.$route.params.id || 'index'
    }
  },
  methods: {
    notifyError ({ type, object }) {
      Vue.notify({
        group: 'plk',
        type: object.type,
        duration: APP_NOTIFICATION_TIME,
        text: this.$t(object.msg)
      })
    }
  }
}
</script>

<style>
</style>
